// src/components/MemoizedPlanComparison.js
import React, { memo } from 'react';
import PlanComparison from './PlanComparison';

// Memoized version of PlanComparison to prevent unnecessary re-renders
const MemoizedPlanComparison = memo(PlanComparison, (prevProps, nextProps) => {
  // Custom comparison function to determine if component should re-render
  
  // Always re-render if critical props change
  if (prevProps.onUpgrade !== nextProps.onUpgrade ||
      prevProps.onDowngrade !== nextProps.onDowngrade ||
      prevProps.onNotification !== nextProps.onNotification) {
    return false; // Re-render
  }
  
  // Only re-render if isResubscription changes
  if (prevProps.isResubscription !== nextProps.isResubscription) {
    return false; // Re-render
  }
  
  // If all props are the same, skip re-render
  return true; // Skip re-render
});

MemoizedPlanComparison.displayName = 'MemoizedPlanComparison';

export default MemoizedPlanComparison;